import React from 'react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { Link } from '@fluentui/react-components';
import { copyrightStyle, footerClassName, privacyLinkStyle } from './StatFooterStyles';

const StatFooter = (): JSX.Element => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className={footerClassName}>
      <Stack horizontal tokens={{ childrenGap: 86 }}>
        <Link
          className={privacyLinkStyle}
          href="http://go.microsoft.com/fwlink/?LinkId=518021"
          target="_blank"
          rel="noopener noreferrer"
        >
          Microsoft Data Privacy Notice
        </Link>
        <span className={copyrightStyle}>{`© ${currentYear} Microsoft`}</span>
      </Stack>
    </footer>
  );
};
export default StatFooter;
